<template>
    <div class="minidiv">
    
        <b-modal :id="'modal-cancel_'+sn" centered title="Confirm Cancel" ok ok-variant="success" cancel-variant="danger" @ok="cancelpayout()">
    
            <template v-slot:modal-ok> Yes, Cancel
</template>
            <p>Are You sure you want cancel this Payout request?</p>
        </b-modal>
        <div class="flex-parent text-center p-1">
            <p class="flex-child">{{ sn + ((page - 1) * interval) }}</p>
            <!-- <p class="flex-child"><b-link :to="{ name : 'editpayout', params : { trackid : payout.trackid }}">{{ payout.title }}</b-link></p> -->
            <p class="flex-child">{{ payout.amount }}</p>
            <p class="flex-child">{{ payout.req_date }}</p>
            <p class="flex-child">{{ payout.req_time }}</p>
            <p class="flex-child">{{ payout.req_status }}</p>
            <p class="flex-child">{{ payout.payment_date }}</p>
            <p><b-button :disabled="payout.req_status == 'Paid'" class="p-1 list-button" variant="danger" @click="comfirmCancel()"> Cancel </b-button></p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    props: ["payout", 'sn', 'page', 'interval'],
    data() {
        return {
            overallscore: 0
        };
    },
    created() {

    },
    methods: {
        ...mapActions("dashboard", ["cancelPayout", "fetchAmbstat"]),
        comfirmCancel() {
            this.$bvModal.show(`modal-cancel_${this.sn}`);
        },
        cancelpayout() {
            let payoutObj = {
                trackid: this.payout.trackid
            }

            // console.log(payoutObj);

            return this.cancelPayout(payoutObj).then(() => {
                this.fetchAmbstat();
                // console.log(response)
            })
        }
    },
    computed: {
        ...mapState({
            allinstitutions: state => state.admin.listinstitutions,
            details: state => state.loginmaster.details,
        })
    }
};
</script>

<style scoped>
.minidiv {
    border-radius: 10px 10px;
    background-color: white;
    /* padding: 5px; */
}

.rins {
    font-size: 0.75rem;
}

.lowscore {
    color: red;
}

.highscore {
    color: #00377b;
}

.totsco {
    color: #00377b;
    font-weight: bolder;
}

.brel {
    text-decoration: none;
    color: black;
}

.link-sol {
    text-decoration: none;
    color: #00984a;
}

.flex-parent {
    display: flex;
    flex-flow: row wrap;
    overflow: auto;
    scrollbar-width: thin;
    /* height: 35px; */
}

.flex-child {
    width: 14%;
    overflow: auto;
    scrollbar-width: thin;
}

@media screen and (max-width: 768px) {
    .flex-child {
        font-size: 0.6rem
    }
    .link-sol {
        font-size: 0.7rem
    }
    .list-button {
        width: contain;
        font-size: 0.6rem;
        padding: 3px;
    }
}
</style>
